const wrapper = "_uxsw1he39om";
const heading = "_uxsh11uc59b";
const singleLineInput = "_uxss1762isk";

export { heading, singleLineInput, wrapper };
import "./atom.input.style.linaria.module.css";
//# sourceMappingURL=atom.input.style.js.map
